import React, { useCallback, useEffect, useRef, useState } from 'react'
import styles from './Product.module.css'
import { Logo } from '../../../Assets/Icons/Windows'
import {
  PerfectPassive,
  PerfectBalance,
  PerfectBalancePro,
  PerfectElegancy,
  PerfectEnergy,
  PerfectExcellent,
} from '../../../Assets/Images/WindowsPage/Product/Index'

// hideLabel — the compare column shows these values without a caption, as in the design
const products = [
  {
    name: "Perfect Passive",
    img: PerfectPassive,
    specs: [
      { param: "P", value: "PVC system, VEKA 82", hideLabel: true },
      { param: "A", value: "Outer wall thickness 3 mm (-0.2)", hideLabel: true },
      {
        param: "Passive Insulation",
        value: "Maximum thermal insulation Uf = 1.0, recommended for passive and energy-efficient houses"
      },
      { param: "Strength", value: "1.49 m²K/W" },
      { param: "Uw coefficient", value: "up to 0.67 W/m²K" },
      { param: "Sealing gaskets", value: "3" },
      { param: "Number of chambers", value: "7" },
      { param: "Installation width", value: "82 mm" },
      { param: "Glazing", value: "32/44/52" },
      { param: "Air permeability", value: "Class 4" },
      { param: "Water tightness", value: "up to 9A" },
      { param: "Security", value: "built-in protection \"anti-burglary window\"" },
      { param: "Living comfort", value: "Integrated blinds with electronic or mechanical control (optional)" },
      { param: "Lamination base", value: "white, graphite, caramel, brown" },
      { param: "Lamination", value: "VEKA SPECTRAL-8, Veka Lamination-56" },
      { param: "EU", value: "designed and certified in the EU" },
    ],
  },
  {
    name: "Perfect Balance",
    img: PerfectBalance,
    specs: [
      { param: "P", value: "PVC system, VEKA76", hideLabel: true },
      { param: "A", value: "Outer wall thickness 3 mm (-0.2)", hideLabel: true },
      {
        param: "Passive Insulation",
        value: "High thermal insulation Uf = 1.2, recommended for energy-efficient houses"
      },
      { param: "Strength", value: "1.18 m²K/W" },
      { param: "Uw coefficient", value: "0.85 W/m²K" },
      { param: "Number of chambers", value: "5" },
      { param: "Installation width", value: "76 mm" },
      { param: "Glazing", value: "32/48" },
      { param: "Air permeability", value: "Class 4" },
      { param: "Water tightness", value: "up to 9A" },
      { param: "Security", value: "built-in protection \"anti-burglary window\"" },
      { param: "Living comfort", value: "Integrated blinds with electronic or mechanical control (optional)" },
      { param: "Lamination base", value: "white, graphite, caramel, brown" },
      { param: "Lamination", value: "VEKA Lamination-56, VEKA Fine Structure-8" },
      { param: "Invisible weld", value: "V-perfect" },
      { param: "EU", value: "designed and certified in the EU" },
    ],
  },
  {
    name: "Perfect Balance Pro",
    img: PerfectBalancePro,
    specs: [
      { param: "P", value: "PVC system, VEKA76", hideLabel: true },
      { param: "A", value: "Outer wall thickness 3 mm (-0.2)", hideLabel: true },
      {
        param: "Passive Insulation",
        value: "High thermal insulation Uf = 1.2, recommended for energy-efficient houses"
      },
      { param: "Strength", value: "1.33 m²K/W" },
      { param: "Uw coefficient", value: "0.75 W/m²K" },
      { param: "Sealing gaskets", value: "3" },
      { param: "Number of chambers", value: "5" },
      { param: "Installation width", value: "76 mm" },
      { param: "Glazing", value: "32/48" },
      { param: "Water tightness", value: "up to 9A" },
      { param: "Air permeability", value: "Class 4" },
      { param: "Security", value: "built-in protection \"anti-burglary window\"" },
      { param: "Living comfort", value: "Integrated blinds with electronic or mechanical control (optional)" },
      { param: "Lamination base", value: "white, graphite, caramel, brown" },
      { param: "Lamination", value: "VEKA Lamination-56, VEKA Fine Structure" },
      { param: "EU", value: "designed and certified in the EU" },
    ],
  },
  {
    name: "Perfect Elegance",
    img: PerfectElegancy,
    specs: [
      { param: "P", value: "PVC system, VEKA 70", hideLabel: true },
      { param: "A", value: "Outer wall thickness 3 mm (-0.2)", hideLabel: true },
      { param: "HI", value: "High thermal insulation Uf = 1.3", hideLabel: true },
      { param: "Strength", value: "1.11 m²K/W" },
      { param: "Uw coefficient", value: "up to 0.9 W/m²K" },
      { param: "Number of chambers", value: "5" },
      { param: "Installation width", value: "70 mm" },
      { param: "Glazing", value: "24/32/40" },
      { param: "Air permeability", value: "Class 4" },
      { param: "Water tightness", value: "up to 9A" },
      { param: "Security", value: "built-in protection \"anti-burglary window\"" },
      { param: "Living comfort", value: "Integrated blinds with electronic or mechanical control (optional)" },
      { param: "Lamination base", value: "white, graphite, caramel, brown" },
      { param: "Lamination", value: "VEKA Lamination-56, VEKA Fine Structure-8" },
      { param: "Invisible weld", value: "V-perfect" },
      { param: "Outward opening", value: "" },
      { param: "EU", value: "designed and certified in the EU" },
    ],
  },
  {
    name: "Perfect Energy",
    img: PerfectEnergy,
    specs: [
      { param: "P", value: "PVC system, WHS by VEKA 72", hideLabel: true },
      { param: "B", value: "Outer wall thickness 2.8 mm (-0.2)", hideLabel: true },
      { param: "HI", value: "High thermal insulation Uf = 1.3", hideLabel: true },
      { param: "Strength", value: "1.11 m²K/W" },
      { param: "Uw coefficient", value: "up to 0.9 W/m²K" },
      { param: "Number of chambers", value: "5" },
      { param: "Installation width", value: "72 mm" },
      { param: "Glazing", value: "24 / 32 / 44" },
      { param: "Water tightness", value: "up to 9A" },
      { param: "Air permeability", value: "Class 4" },
      { param: "Security", value: "built-in protection \"anti-burglary window\"" },
      { param: "Living comfort", value: "Integrated blinds with electronic or mechanical control (optional)" },
      { param: "Lamination base", value: "white, graphite, brown" },
      { param: "Lamination", value: "Perfect Lamination-36" },
      { param: "EU", value: "designed and certified in the EU" },
    ],
  },
  {
    name: "Perfect Excellent",
    img: PerfectExcellent,
    specs: [
      { param: "P", value: "PVC system, WHS by VEKA 60", hideLabel: true },
      { param: "B", value: "Outer wall thickness 2.8 mm (-0.2)", hideLabel: true },
      { param: "HI", value: "High thermal insulation Uf = 1.5", hideLabel: true },
      { param: "Strength", value: "1.00 m²K/W" },
      { param: "Uw coefficient", value: "up to 1 W/m²K" },
      { param: "Number of chambers", value: "4" },
      { param: "Installation width", value: "60 mm" },
      { param: "Glazing", value: "24 / 32" },
      { param: "Water tightness", value: "up to 9A" },
      { param: "Air permeability", value: "Class 4" },
      { param: "Security", value: "built-in protection \"anti-burglary window\"" },
      { param: "Lamination base", value: "white" },
      { param: "Lamination", value: "Perfect Lamination-36" },
      { param: "EU", value: "designed and certified in the EU" },
    ],
  },
];

const CompareIcon = () => (
  <svg className={styles.compareBox_icon} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path d="M10 2C10.1326 2 10.2598 2.05268 10.3536 2.14645C10.4473 2.24021 10.5 2.36739 10.5 2.5V17.5L10.49 17.6C10.467 17.713 10.4057 17.8146 10.3164 17.8876C10.2271 17.9606 10.1153 18.0005 10 18.0005C9.88466 18.0005 9.77287 17.9606 9.68357 17.8876C9.59427 17.8146 9.53295 17.713 9.51 17.6L9.5 17.5V2.5C9.5 2.36739 9.55268 2.24021 9.64645 2.14645C9.74021 2.05268 9.86739 2 10 2ZM6 6.5C6.53043 6.5 7.03914 6.71071 7.41421 7.08579C7.78929 7.46086 8 7.96957 8 8.5V11.5C8 12.0304 7.78929 12.5391 7.41421 12.9142C7.03914 13.2893 6.53043 13.5 6 13.5H3C2.46957 13.5 1.96086 13.2893 1.58579 12.9142C1.21071 12.5391 1 12.0304 1 11.5V8.5C1 7.96957 1.21071 7.46086 1.58579 7.08579C1.96086 6.71071 2.46957 6.5 3 6.5H6ZM17 6.5C17.5304 6.5 18.0391 6.71071 18.4142 7.08579C18.7893 7.46086 19 7.96957 19 8.5V11.5C19 12.0304 18.7893 12.5391 18.4142 12.9142C18.0391 13.2893 17.5304 13.5 17 13.5H14C13.4696 13.5 12.9609 13.2893 12.5858 12.9142C12.2107 12.5391 12 12.0304 12 11.5V8.5C12 7.96957 12.2107 7.46086 12.5858 7.08579C12.9609 6.71071 13.4696 6.5 14 6.5H17Z" />
  </svg>
)

const TickIcon = () => (
  <svg className={styles.compareBox_tick} viewBox="0 0 15 15" fill="none" aria-hidden="true">
    <path d="M12.5 3.75L5.625 10.625L2.5 7.5" stroke="currentColor" strokeWidth="2.08325" strokeLinecap="round"
          strokeLinejoin="round" />
  </svg>
)

const ChevronIcon = ({ back }) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d={back ? "M15 5L8 12L15 19" : "M9 5L16 12L9 19"} stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const Product = () => {
  const [active, setActive] = useState(0)
  // const [rotation, setRotation] = useState(32)
  const [compareMode, setCompareMode] = useState(false)
  const [compared, setCompared] = useState([])
  const [page, setPage] = useState(0)
  const [pages, setPages] = useState(1)
  const trackRef = useRef(null)
  const current = products[active]

  const toggleCompareMode = () => {
    setCompareMode((open) => !open)
    setCompared([])
  }

  const toggleCompared = (index) => {
    setCompared((list) => (
      list.includes(index) ? list.filter((i) => i !== index) : [...list, index]
    ))
  }

  // how many columns fit on screen is decided by CSS, so read it back off the DOM
  const metrics = useCallback(() => {
    const track = trackRef.current
    const items = track ? Array.from(track.children) : []
    if (!items.length) return null

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0
    const step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth + gap
    const perView = Math.max(1, Math.floor((track.clientWidth + gap) / step))
    return { track, count: items.length, step, perView }
  }, [])

  useEffect(() => {
    const track = trackRef.current
    if (!track) return

    // the track advances one card at a time, so a "page" is one scroll position
    const measure = () => {
      const m = metrics()
      if (!m) return
      setPages(Math.max(1, m.count - m.perView + 1))
      setPage(Math.round(track.scrollLeft / m.step))
    }

    measure()
    track.addEventListener('scroll', measure, { passive: true })
    window.addEventListener('resize', measure)
    return () => {
      track.removeEventListener('scroll', measure)
      window.removeEventListener('resize', measure)
    }
  }, [metrics, compared, compareMode])

  const goTo = (index) => {
    const m = metrics()
    if (m) m.track.scrollTo({ left: index * m.step, behavior: 'smooth' })
  }

  return (
    <section className={styles.wrap} id="product">
      <div className={`customContainer ${styles.container}`}>

        {/* PREVIEW BLOCK */}
        <div className={styles.previewGroup}>
          <div className={styles.preview}>

            {/* LEFT — BIG PREVIEW */}
            <div className={styles.gallery}>
              <div className={styles.head}>
                <h2 className={styles.head_title}>{current.name}</h2>
                <span className={styles.head_line}></span>
              </div>

              <div className={styles.stage}>
                <img src={current.img} alt={current.name} className={styles.stage_img} />

                {/*<button type="button" className={styles.rotate}>*/}
                {/*  <img src={Rotate360} alt="" className={styles.rotate_icon} />*/}
                {/*  <span>Rotate</span>*/}
                {/*</button>*/}

                {/*<div className={styles.rangeWrap}>*/}
                {/*  <input*/}
                {/*    type="range"*/}
                {/*    min="0"*/}
                {/*    max="100"*/}
                {/*    value={rotation}*/}
                {/*    onChange={(e) => setRotation(Number(e.target.value))}*/}
                {/*    className={styles.range}*/}
                {/*    style={{ '--progress': `${rotation}%` }}*/}
                {/*    aria-label={`Rotate ${current.name}`}*/}
                {/*  />*/}
                {/*</div>*/}
              </div>
            </div>

            {/* RIGHT — BUTTON & THUMBNAILS */}
            <div className={styles.side}>
              <div className={styles.compareWrap}>
                <button
                  type="button"
                  onClick={toggleCompareMode}
                  aria-pressed={compareMode}
                  className={`${styles.compareBtn} ${compareMode ? styles.compareBtn_on : ''}`}
                >
                  Compare product
                </button>
              </div>

              <div className={styles.thumbs}>
                {products.map((item, index) => (
                  <div className={`${styles.thumb} ${active === index ? styles.thumb_active : ''}`} key={item.name}>
                    <button type="button" onClick={() => setActive(index)} className={styles.thumb_pick}>
                      <img src={item.img} alt={item.name} className={styles.thumb_img} />
                      <span className={styles.thumb_overlay}>
                        {active === index ? "Selected" : item.name}
                      </span>
                    </button>

                    {compareMode && (
                      <label
                        className={`${styles.compareBox} ${compared.includes(index) ? styles.compareBox_on : ''}`}
                      >
                        <CompareIcon />
                        <input
                          type="checkbox"
                          checked={compared.includes(index)}
                          onChange={() => toggleCompared(index)}
                          className={styles.compareBox_input}
                          aria-label={`Compare ${item.name}`}
                        />
                        <span className={styles.compareBox_box}><TickIcon /></span>
                      </label>
                    )}
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* COMPARISON */}
          {compareMode && compared.length > 0 && (
            <div className={styles.compareBlock}>
              <div className={styles.compare} ref={trackRef}>
                {compared.map((index) => (
                  <div className={styles.compareItem} key={products[index].name}>
                    <div className={styles.compareItem_head}>
                      <h3 className={styles.compareItem_title}>{products[index].name}</h3>
                      <span className={styles.compareItem_line}></span>
                    </div>

                    <div className={styles.compareItem_imageWrap}>
                      <img src={Logo} alt="XLeum Windows" className={styles.compareItem_logo} />
                      <img
                        src={products[index].img}
                        alt={products[index].name}
                        className={styles.compareItem_img}
                      />
                    </div>

                    <div className={styles.compareItem_specs}>
                      {products[index].specs.map((item) => (
                        <div className={styles.compareRow} key={item.param}>
                          {!item.hideLabel && <span className={styles.compareRow_name}>{item.param}</span>}
                          <span className={styles.compareRow_value}>{item.value}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {pages > 1 && (
                <>
                  <button
                    type="button"
                    onClick={() => goTo(page - 1)}
                    disabled={page === 0}
                    className={`${styles.compareArrow} ${styles.compareArrow_prev}`}
                    aria-label="Previous products"
                  >
                    <ChevronIcon back />
                  </button>

                  <button
                    type="button"
                    onClick={() => goTo(page + 1)}
                    disabled={page >= pages - 1}
                    className={`${styles.compareArrow} ${styles.compareArrow_next}`}
                    aria-label="Next products"
                  >
                    <ChevronIcon />
                  </button>
                </>
              )}
            </div>
          )}
        </div>

        {/* TECHNICAL SPECIFICS */}
        <div className={styles.info}>
          <div className={styles.info_head}>
            <h3 className={styles.info_title}>Technical Specifics</h3>
            <span className={styles.info_line}></span>
          </div>

          <div className={styles.specs}>
            {current.specs.map((item) => (
              <div className={styles.specs_row} key={item.param}>
                <div className={styles.specs_param}>{item.param}</div>
                <div className={styles.specs_value}>{item.value}</div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  )
}

export default Product
